export default class MenuController {

  constructor($rootScope) {
    $rootScope.$on("$routeChangeStart", function(event, next, current) {
      if (next.params.language) {
        app.translate.use(next.params.language)
          .then((success) => {
              app.language = success;
          });
      }
    });
  }

  logout() {
    app.logout();
  }

  get isAuth() {
    return app.authData;
  }

  get language() {
    return app.language;
  }

}

MenuController.$inject = ['$rootScope'];



/** WEBPACK FOOTER **
 ** ./public/app/MenuController.js
 **/